import { Effect, all } from "redux-saga/effects"
import { Injector } from "../di/Injector"
import { events } from "./events/sagas"

export function* domain(injector: Injector): Generator<Effect> {
  yield all([events(injector)])
}
